import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { css, withStyles } from '../../assets/styles/withStyles';
import { loadCategories } from '../../redux/actions/categories';
import { getAllCategories } from '../../redux/selectors/categories';
import { loadInfo } from '../../redux/actions/info';
import { getInfo } from '../../redux/selectors/info';
import Responsive from '../../components/helpers/Responsive';

class Menu extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedMenu: null,
      selectedWork: null,
      menuOpened: false
    };

    this._toggleMobileMenu = this._toggleMobileMenu.bind(this);
    this._goToHome = this._goToHome.bind(this);
  }

  componentDidMount() {
    this.props.loadCategories();
    this.props.loadInfo();
  }

  componentDidUpdate() {
    let paths = this.props.location.pathname.split('/');
    let menu = paths[1];

    if (menu !== this.state.selectedMenu) {
      switch (menu) {
        case 'work':
        case 'about':
        case 'all':
          this.setState({
            selectedMenu: menu,
            menuOpened: false
          });
          break;
        default:
          if (this.state.selectedMenu) {
            this.setState({
              selectedMenu: null,
              menuOpened: false
            });
          }
          break;
      }
    }

    if (paths.length >= 3) {
      let work = paths[2];

      if (work !== this.state.selectedWork) {
        this.setState({
          selectedWork: work,
          menuOpened: false
        });
      }
    } else {
      if (this.state.selectedWork) {
        this.setState({
          selectedWork: null,
          menuOpened: false
        });
      }
    }
  }

  _toggleMobileMenu() {
    this.setState({
      menuOpened: !this.state.menuOpened
    });
  }

  _goToHome() {
    this.props.history.push('/');
  }

  _renderMobileMenu() {
    const { styles, info } = this.props;
    const { selectedMenu, menuOpened } = this.state;

    return (
      <Responsive max="tablet">
        <div {...css(styles.mobileMenu, menuOpened && styles.menuOpened)}>
          <div {...css(styles.mobileMenuInner)}>
            <ul>
              <li {...css(styles.linkWrapper)}>
                <Link
                  to="/work"
                  {...css(
                    styles.link,
                    (selectedMenu === null || selectedMenu === 'work') &&
                      styles.selectedLink
                  )}
                >
                  Work
                </Link>
              </li>
              <li {...css(styles.linkWrapper)}>
                <Link
                  to="/about"
                  {...css(
                    styles.link,
                    selectedMenu === 'about' && styles.selectedLink
                  )}
                >
                  About
                </Link>
              </li>
              <li {...css(styles.linkWrapper)}>
                <Link
                  to="/all"
                  {...css(
                    styles.link,
                    selectedMenu === 'all' && styles.selectedLink
                  )}
                >
                  All
                </Link>
              </li>
            </ul>
            {this._renderWorkMenu()}
          </div>
          {info && (
            <div {...css(styles.mobileMenuAddress)}>
              <p {...css(styles.address)}>{info.address_1}</p>
              <p {...css(styles.address)}>{info.address_2}</p>
              <p {...css(styles.address)}>{info.phone}</p>
              <p {...css(styles.address)}>{info.email}</p>
            </div>
          )}
        </div>
      </Responsive>
    );
  }

  _renderMenu() {
    const { styles } = this.props;
    const { selectedMenu } = this.state;

    return (
      <Responsive min="desktop">
        <div {...css(styles.menu)}>
          <ul>
            <li {...css(styles.linkWrapper)}>
              <Link
                to="/work"
                {...css(
                  styles.link,
                  (selectedMenu === null || selectedMenu === 'work') &&
                    styles.selectedLink
                )}
              >
                Work
              </Link>
            </li>
            <li {...css(styles.linkWrapper)}>
              <Link
                to="/about"
                {...css(
                  styles.link,
                  selectedMenu === 'about' && styles.selectedLink
                )}
              >
                About
              </Link>
            </li>
            <li {...css(styles.linkWrapper)}>
              <Link
                to="/all"
                {...css(
                  styles.link,
                  selectedMenu === 'all' && styles.selectedLink
                )}
              >
                All
              </Link>
            </li>
          </ul>
          {this._renderWorkMenu()}
        </div>
      </Responsive>
    );
  }

  _renderWorkMenu() {
    const { styles, categories } = this.props;
    const { selectedWork } = this.state;

    return (
      <ul {...css(styles.workLinks)}>
        {categories.map(menu => (
          <li key={menu.id} {...css(styles.linkWrapper)}>
            <Link
              to={'/work/' + menu.slug}
              {...css(
                styles.link,
                selectedWork === menu.slug && styles.selectedLink
              )}
            >
              {menu.name}
            </Link>
          </li>
        ))}
      </ul>
    );
  }

  _renderInfo() {
    const { styles, info } = this.props;

    if (!info) return null;

    return (
      <div {...css(styles.addressWrapper)}>
        <p {...css(styles.address)}>{info.address_1}</p>
        <p {...css(styles.address)}>{info.address_2}</p>
        <p {...css(styles.address)}>{info.phone}</p>
        <p {...css(styles.address)}>{info.email}</p>
      </div>
    );
  }

  render() {
    const { styles } = this.props;
    const { menuOpened } = this.state;

    return (
      <div {...css(styles.menuWrapper)}>
        <p onClick={this._goToHome} {...css(styles.title)}>
          Amélia e Rodrigo
          <br />
          Architecture Matters
        </p>

        <Responsive max="tablet">
          <div {...css(styles.mobileButton)} onClick={this._toggleMobileMenu}>
            {menuOpened ? '-' : '+'}
          </div>
        </Responsive>

        {this._renderMobileMenu()}
        {this._renderMenu()}

        {this._renderInfo()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  categories: getAllCategories(state),
  info: getInfo(state)
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      loadCategories,
      loadInfo
    },
    dispatch
  );
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    withStyles(({ breakpoints }) => ({
      menuWrapper: {
        paddingTop: 10,
        paddingRight: 15,
        paddingBottom: 10,
        paddingLeft: 15,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        zIndex: 30,

        [breakpoints.md]: {
          position: 'fixed',
          top: 0,
          bottom: 0,
          left: 0,
          width: '33%',
          borderRightStyle: 'solid',
          borderRightWidth: 2,
          borderRightColor: 'black'
        }
      },
      mobileButton: {
        fontSize: 26,
        position: 'fixed',
        top: 0,
        right: 0,
        width: 44,
        height: 44,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer'
      },
      mobileMenu: {
        display: 'none',
        marginTop: 25.5
      },
      menuOpened: {
        display: 'flex',
        flexDirection: 'column'
      },
      mobileMenuInner: {
        display: 'flex',
        flexDirection: 'row'
      },
      mobileMenuAddress: {
        marginTop: 80,
        marginBottom: 10
      },
      title: {
        fontSize: 22,
        lineHeight: '26px',
        cursor: 'pointer',

        [breakpoints.sm]: {
          fontSize: 26,
          lineHeight: '30px'
        },

        [breakpoints.lg]: {
          fontSize: 27,
          lineHeight: '33px'
        }
      },
      menu: {
        display: 'flex',
        marginTop: 52,
        flexDirection: 'row',

        [breakpoints.sm]: {
          marginTop: 60
        },

        [breakpoints.lg]: {
          marginTop: 66
        }
      },
      linkWrapper: {
        lineHeight: '26px',

        [breakpoints.sm]: {
          lineHeight: '30px'
        },

        [breakpoints.lg]: {
          lineHeight: '33px'
        }
      },
      link: {
        display: 'block',
        fontSize: 22,
        lineHeight: '26px',

        [breakpoints.sm]: {
          fontSize: 26,
          lineHeight: '30px'
        },

        [breakpoints.lg]: {
          fontSize: 27,
          lineHeight: '33px'
        }
      },
      selectedLink: {
        textDecoration: 'underline'
      },
      workLinks: {
        paddingLeft: 40,

        [breakpoints.md]: {
          paddingLeft: 30
        }
      },
      addressWrapper: {
        display: 'none',

        [breakpoints.md]: {
          display: 'block',
          position: 'absolute',
          bottom: 30,
          left: 15,
          right: 15
        }
      },
      address: {
        lineHeight: '20px',
        fontSize: 17
      }
    }))(Menu)
  )
);



// WEBPACK FOOTER //
// ./src/containers/Menu/index.js